function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #35424b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_26",
  "data-name": "Ret\\xE2ngulo 26",
  className: "cls-1",
  width: 7.19,
  height: 7.192,
  transform: "translate(0 0)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_28",
  "data-name": "Grupo 28",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_27",
  "data-name": "Grupo 27",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_29",
  "data-name": "Caminho 29",
  className: "cls-3",
  d: "M5.922.222h0a.718.718,0,0,1,1.038,0,.692.692,0,0,1,0,1.031L4.629,3.594,6.96,5.934a.711.711,0,0,1,0,1.048.746.746,0,0,1-1.038,0L3.589,4.641,1.248,6.982a.746.746,0,0,1-1.038,0,.759.759,0,0,1,0-1.048l2.331-2.34L.21,1.253A.738.738,0,0,1,.21.222a.718.718,0,0,1,1.038,0L3.589,2.545Z"
})));

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.19,
    height: 7.192,
    viewBox: "0 0 7.19 7.192",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x.553f4095.svg";
export { ForwardRef as ReactComponent };